/* eslint-disable import/prefer-default-export */
export const GET_HISTORY_ENTRY = 'GET_HISTORY_ENTRY';
